module.exports = __webpack_public_path__ + "static/upwork-69e29fc1a6e69461e6920a55da39126b.jpg";